/* eslint-disable */
export default {
  log: 'Journal',
} as const;

// @key: @#@"log"@#@ @source: @#@"Log"@#@
